module.exports = __webpack_public_path__ + "img/girlschool.8fa1ce4c.jpg";